var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0537 9.31641H13.4228V15.4771",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0537 15.4756H14.7918",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47061 3.84082C2.10752 3.84082 1.75929 3.98506 1.50255 4.24181C1.2458 4.49855 1.10156 4.84677 1.10156 5.20987V17.5313C1.10156 17.8944 1.2458 18.2426 1.50255 18.4994C1.75929 18.7561 2.10752 18.9003 2.47061 18.9003H17.5301C17.8932 18.9003 18.2414 18.7561 18.4982 18.4994C18.7549 18.2426 18.8992 17.8944 18.8992 17.5313V5.20987C18.8992 4.84677 18.7549 4.49855 18.4982 4.24181C18.2414 3.98506 17.8932 3.84082 17.5301 3.84082H14.792",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2085 1.10059V6.57678",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.792 1.10059V6.57678",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20801 3.84082H12.0532",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20801 9.31641H8.63063L6.57706 12.0545C6.57706 12.0545 8.63063 12.0545 8.63063 13.4235C8.66926 13.7023 8.64276 13.9862 8.55322 14.2529C8.46368 14.5197 8.31353 14.7621 8.11456 14.9611C7.91558 15.16 7.6732 15.3102 7.40644 15.3997C7.13967 15.4893 6.85578 15.5158 6.57706 15.4771H5.20801",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGroup);
export default __webpack_public_path__ + "static/media/calendar-group.88003e068709350cf979ace44c41616a.svg";
export { ForwardRef as ReactComponent };